<template>
  <section :id="id">
    <section-hero-alt/>

    <section-about-our-product title="Котлы" :cards="pots" />
    <section-about-our-product title="Котельно-Вспомогательное Оборудование" :cards="equipment" />

    <section-info />
  </section>
</template>

<script>
  // Extensions
  import View from '@/views/View'

  export default {
    name: 'About',
    components: {
      SectionHeroAlt: () => import('@/views/sections/HeroAlt.vue'),
      SectionAboutOurProduct: () => import('@/views/sections/AboutOurProduct.vue'),
      SectionInfo: () => import('@/views/sections/Info.vue')
    },
    metaInfo: { title: 'Продукция' },
    extends: View,
    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
    data: () => ({
      pots: [
        {
          title: 'паровые жаротрубные',
          subtitle: 'Котлы',
          text: 'паропроизводительностью от 0,5 до 25 т/ч с рабочим давлением пара от 0,9 до 1,4 МПа',
          id: '5'
        },
        {
          title: 'водогрейные жаротрубные',
          subtitle: 'Котлы',
          text: 'теплопроизводительностью от 0,8 до 4 МВт (от 800 до 4000 КВт) с температурой воды на выходе из котла не более 95 °С и рабочим давлением не более 0,6МПа (6 кгс/см)',
          id: '6'
        },
        {
          title: 'отопительные водогрейные 1,55-40 МВт',
          subtitle: 'Котлы',
          text: 'теплопроизводительностью от 1,55 до 40 МВт с температурой воды на выходе из котла не менее 115/150 °С',
          id: '7'
        },
        {
          title: 'отопительные водогрейные 58-139,2 МВт',
          subtitle: 'Котлы',
          text: 'теплопроизводительностью от 58 до 139,2 МВт с температурой воды на выходе из котла не менее 150 °С',
          id: '8'
        },
      ],
      equipment: [
        {
          title: 'Деаэраторы вакуумные',
          subtitle: '',
          text: 'номинальной производительностью от 5 т/ч до 150т/ч',
          id: '9'
        },
        {
          title: 'Деаэраторы атмосферные',
          subtitle: '',
          text: 'номинальной производительностью от 5т/ч до 100т/ч',
          id: '10'
        },
        {
          title: 'Теплообменники (подогреватели) пароводяные',
          subtitle: '',
          text: 'теплопроизводительностью от 1,5 до 37,2 МВт',
          id: '11'
        },
        {
          title: 'Теплообменники (подогреватели) водоводяные',
          subtitle: '',
          text: 'секционные длиной секции 2000-4000 мм, изготавливаемые по ГОСТ 27590-2005.',
          id: '12'
        },
        {
          title: 'Подогреватели мазута',
          subtitle: '',
          text: 'производительностью по мазуту от 6 до 60 т/ч',
          id: '13'
        },
        {
          title: 'Фильтры для мазута',
          subtitle: '',
          text: 'производительностью 30 т/ч',
          id: '14'
        },
        {
          title: 'Холодильники отбора проб',
          subtitle: '',
          text: 'двухточечные',
          id: '15'
        },
        {
          title: 'Сепараторы непрерывной продувки',
          subtitle: '',
          text: '',
          id: '16'
        },
        {
          title: 'Резервуары (емкости) горизонтальные',
          subtitle: '',
          text: 'цилиндрические с плоскими днищами, от 5 м³ до 100 м³',
          id: '17'
        },
        {
          title: 'Резервуары (баки) вертикальные',
          subtitle: '',
          text: 'цилиндрические, от 1 м³ до 25 м³',
          id: '18'
        },
        {
          title: 'Грязевики от Ду 40 до Ду 1000',
          subtitle: '',
          text: '',
          id: '19'
        },
        {
          title: 'Унифицированные водонапорные стальные башни системы Рожновского',
          subtitle: '',
          text: 'всех модификаций',
          id: '20'
        },
      ]
    })
  }
</script>

<style lang="scss" scoped>
.about-our-product {
  padding-bottom: 0 !important;
}

</style>
